import React from 'react'
import system from 'system-components'
import styled from 'styled-components'
import withState from 'recompose/withState'
import { Icon } from 'components'

export const Heading = system(
  {
    is: 'h1',
    // m: 0,
    position: 'relative',
    // color: 'dark-gray',
    // fontFamily: 'sansSerif',
  },
  'color',
  'space',
  'fontSize',
  'width',
  'textAlign',
  'display',
  'lineHeight',
  'fontWeight',
  'letterSpacing'
)

Heading.displayName = 'Heading'

const IconWrap = styled.span`
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  height: 1em;
`

// Hacked to get the color right
const Link = styled.a`
  vertical-align: middle;
  color: inherit;
  :hover {
    color: inherit;
  }
  :active {
    color: inherit;
  }
  font-weight: 700;
`

// TODO -- Show anchor link on hover
export const HeadingWithAnchor = withState(
  'showAnchor', 'setShowAnchor', false
)(({
  children,
  id,
  showAnchor,
  setShowAnchor,
  ...rest
}) => (
  id ? (
    <Heading id={id} {...rest}>
      <Link href={`#${id}`}
        onMouseEnter={() => setShowAnchor(true)}
        onMouseLeave={() => setShowAnchor(false)}>
        {children}
      </Link>
      <IconWrap>
        {id && showAnchor && <Icon ml={2} mt="3px" name="link" size="24px" color="gray.4" />}
      </IconWrap>
    </Heading>
  ) : <Heading {...rest}>{children}</Heading>
))

export default Heading



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Heading.js